export const state = {
    modulesLabels: ["booking", "click-and-collect", "gift-vouchers", "website"],
};

export default state;
